import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { Button, WeezHeader } from '@weezevent/nacre';
import { TemplateDetails } from '@weezevent/templar';

const TemplateInformation = ({ id, organizationId = 0 }) => {
    const { t } = useTranslation();
    const history = useHistory();

    return (
        <>
            <WeezHeader
                title={t('sauron.emails.templates.brandkits.templates-details')}
                backLink={{
                    onClick: () => {
                        if (organizationId) {
                            history.push(`/organizations/O${organizationId}/emails/templates/templates`);
                        } else {
                            history.push(`/emails/templates/templates`);
                        }
                    }
                }}
                rightComponent={[
                    <Button key={'edit-template'} primary onClick={() => history.push(`${id}/edit`)}>
                        {t('sauron.emails.templates.templates.edit-design')}
                    </Button>
                ]}
            />
            <TemplateDetails id={id} organizationId={organizationId} editUrl={`${id}/edit`} />
        </>
    );
};

export default TemplateInformation;
